<template></template>
<script>
    import BlogAboveTheFoldComponent from "../../components/pagesbuilder/dynamic-components/BlogAboveTheFoldComponent";
    import PreviewComponent from './PreviewComponent.vue';
    export default {
        name: "PreviewBlogAboveTheFoldComponent",
        mixins: [PreviewComponent, BlogAboveTheFoldComponent],
    }
</script>
